__turbopack_context__.v({
  "analyzingBadge": "ClientAvatar-module__XpvDXq__analyzingBadge",
  "analyzingText": "ClientAvatar-module__XpvDXq__analyzingText",
  "container": "ClientAvatar-module__XpvDXq__container",
  "emptyActions": "ClientAvatar-module__XpvDXq__emptyActions",
  "loaderContainer": "ClientAvatar-module__XpvDXq__loaderContainer",
  "noOfferBox": "ClientAvatar-module__XpvDXq__noOfferBox",
  "notGeneratedMessage": "ClientAvatar-module__XpvDXq__notGeneratedMessage",
  "offerField": "ClientAvatar-module__XpvDXq__offerField",
  "offerLabel": "ClientAvatar-module__XpvDXq__offerLabel",
  "offerSelect": "ClientAvatar-module__XpvDXq__offerSelect",
  "offerSelectWrapper": "ClientAvatar-module__XpvDXq__offerSelectWrapper",
  "offerSelector": "ClientAvatar-module__XpvDXq__offerSelector",
  "offerSelectorLeft": "ClientAvatar-module__XpvDXq__offerSelectorLeft",
  "rightActions": "ClientAvatar-module__XpvDXq__rightActions",
});
